(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["alert~collapse~config-provider~dropdown~form~grid~index~input~input-number~loading~locale-provider~m~39b918fb"],{

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: resetWarned

// CONCATENATED MODULE: ./src/base/vc-util/warning.js
/* eslint-disable no-console */
var warned = {};
function warning(valid, message) {
  // Support uglify
  if (false) {}
}
function note(valid, message) {
  // Support uglify
  if (false) {}
}
function resetWarned() {
  warned = {};
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning, valid, message);
}
function noteOnce(valid, message) {
  call(note, valid, message);
}
/* harmony default export */ var vc_util_warning = (warningOnce);
/* eslint-enable */
// CONCATENATED MODULE: ./src/utils/warning.js


/* harmony default export */ var utils_warning = __webpack_exports__["a"] = (function (valid, component) {
  var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  vc_util_warning(valid, "[antdv: ".concat(component, "] ").concat(message));
});

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeConfirmLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getConfirmLocale; });
/* harmony import */ var _base_locale_zh_CN__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var runtimeLocale = _objectSpread({}, _base_locale_zh_CN__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].Modal);

function changeConfirmLocale(newLocale) {
  if (newLocale) {
    runtimeLocale = _objectSpread(_objectSpread({}, runtimeLocale), newLocale);
  } else {
    runtimeLocale = _objectSpread({}, _base_locale_zh_CN__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].Modal);
  }
}
function getConfirmLocale() {
  return runtimeLocale;
}

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANT_MARK", function() { return ANT_MARK; });
/* harmony import */ var utils_vue_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_interopDefault__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
/* harmony import */ var components_modal_locale__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48);
/* harmony import */ var utils_warning__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var ANT_MARK = 'internalMark';

function setMomentLocale(locale) {
  if (locale && locale.locale) {
    Object(utils_interopDefault__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(moment__WEBPACK_IMPORTED_MODULE_1__).locale(locale.locale);
  } else {
    Object(utils_interopDefault__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(moment__WEBPACK_IMPORTED_MODULE_1__).locale('zh_CN');
  }
}

var LocaleProvider = {
  name: 'ALocaleProvider',
  props: {
    locale: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].object.def(function () {
      return {};
    }),
    _ANT_MARK__: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string
  },
  data: function data() {
    Object(utils_warning__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this._ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead');
    return {
      antLocale: _objectSpread(_objectSpread({}, this.locale), {}, {
        exist: true
      })
    };
  },
  provide: function provide() {
    return {
      localeData: this.$data
    };
  },
  watch: {
    locale: function locale(val) {
      this.antLocale = _objectSpread(_objectSpread({}, this.locale), {}, {
        exist: true
      });
      setMomentLocale(val);
      Object(components_modal_locale__WEBPACK_IMPORTED_MODULE_3__[/* changeConfirmLocale */ "a"])(val && val.Modal);
    }
  },
  created: function created() {
    var locale = this.locale;
    setMomentLocale(locale);
    Object(components_modal_locale__WEBPACK_IMPORTED_MODULE_3__[/* changeConfirmLocale */ "a"])(locale && locale.Modal);
  },
  beforeDestroy: function beforeDestroy() {
    Object(components_modal_locale__WEBPACK_IMPORTED_MODULE_3__[/* changeConfirmLocale */ "a"])();
  },
  render: function render() {
    return this.$slots.default ? this.$slots.default[0] : null;
  }
};
/* istanbul ignore next */

LocaleProvider.install = function (Vue) {
  // Vue.use(Base);
  Vue.component(LocaleProvider.name, LocaleProvider);
};

/* harmony default export */ __webpack_exports__["default"] = (LocaleProvider);

/***/ })

}]);